// extracted by mini-css-extract-plugin
export var auto = "_43-1";
export var spinner = "_43-0";